import AppService from './AppService';

class UserService extends AppService {
  me() {
    return this.http.get('/users');
  }
}

export default new UserService();
